
define('text!templates/main/utilities.html',[],function () { return '<div class="text-center full" style="overflow:auto;">\n    <div class="midalign helper"></div>\n    <div class="midalign">\n        <h2 class="heading">What are you looking for?</h2>\n        <ul class="list-group inline-block" id="utilityList"></ul>\n    </div>\n</div>';});

